import Vue from 'vue'
// import { Message } from 'element-ui';
// // import { Loading } from 'element-ui';
// import { MessageBox } from 'element-ui';
import { Dialog, Toast, ImagePreview } from 'vant';
import _ from 'lodash'

const utils = {
  getUniqid: function (length) {
    length = length || 8;
    var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i)
      result += str[Math.floor(Math.random() * str.length)];
    return result;
  },
  isWeixin() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
  },
  // 多级联动数据转tree
  tmpTreeId: 10000,
  cascader2tree: (columns) => {
    let _arr = []
    columns.forEach(element => {
      let _children = [];
      if (element.children) {
        _children = utils.cascader2tree(element.children)
      }
      if (!_.isEmpty(_children)) {
        _arr.push({
          id: utils.tmpTreeId++,
          label: element.value,
          children: _children
        })
      } else {
        _arr.push({
          id: utils.tmpTreeId++,
          label: element.value,
          // children: _children
        })
      }
    });
    return _arr
  },
  tree2cascader: (columns) => {
    let _arr = []
    columns.forEach(element => {
      let _children = [];
      if (element.children) {
        _children = utils.tree2cascader(element.children)
      }
      if (!_.isEmpty(element.label)) {
        // 没有的不要加children
        if (!_.isEmpty(_children)) {
          _arr.push({
            value: element.label,
            children: _children
          })
        } else {
          _arr.push({
            value: element.label,
            // children: _children
          })
        }

      }

    });
    return _arr
  },
  // 分类数据转多级 id: 18, pid: 0, cat_name: '测试'
  toTree: (data = [], config = {}) => {
    const { id = "id", pid = "pid" } = config;
    // 浅拷贝精髓所在
    const newData = _.cloneDeep(data);// JSON.parse(JSON.stringify(data));
    // 存放结果
    const result = [];
    // 存放平铺数据
    const allNodeMap = {};
    // 不是Array不处理
    if (!Array.isArray(newData)) {
      return result;
    }
    // 清除原有的children，以及平铺数据
    newData.forEach((item) => {
      delete item._child;
      allNodeMap[item[id]] = item;
    });
    // 核心代码
    newData.forEach((item) => {
      const parent = allNodeMap[item[pid]];
      if (parent) {
        (parent._child || (parent._child = [])).push(item)
      } else {
        result.push(item)
      }
    });

    return result;
  },
  //网络请求
  request: (url, formData, callback) => {


    // let _loadingMessage = Message({ showClose: true, message: 'Loading...', type: 'info',duration:2000 });

    formData = formData || {};
    if (!formData['source']) {
      formData['source'] = 'diy';
    }

    Vue.http.post(url, formData, { emulateJSON: true }).then(function (response) {
      let res = response.data;

      // console.log('response',res)


      //出错时弹出提示
      if (res.code == 0) {

        // if(!_.isEmpty( res.login_url)){


        //   MessageBox.confirm('亲，登陆后再操作，方便您后期管理', '登陆提示', {
        //     confirmButtonText: '登陆',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //       //网页跳转link
        //       var a = document.createElement('a');
        //       a.href = res.login_url;
        //       var target_href = document.createAttribute("target");
        //       target_href.nodeValue = "_blank";
        //       a.setAttributeNode(target_href);
        //       a.click();
        //   }).catch(() => {

        //   });


        // }else{
        //   MessageBox.alert(res.msg, '提示',{
        //     type: 'warning',
        //     dangerouslyUseHTMLString: true
        //   })
        // }
      } else if (res.code == 1) {
        //成功并有msg时自动弹出
        if (!_.isEmpty(res.msg) && res.msg != 'success') {
          // MessageBox.alert(res.msg, '提示',{
          //   type: 'success',
          //   dangerouslyUseHTMLString: true
          // })

        }

      }

      //无论是否成功都会回调
      if (typeof callback == "function") {
        callback(res);
      }

      // _loadingMessage.close();


    }).catch(function (error) {
      console.log(error);
      // MessageBox.alert('请求发生错误，请稍后再试...', '错误提示')
    });


  },
  formDataFieldCheck: function (pluginName) {
    return _.includes([
      'field',
      'switchOff',
      'checkboxGroup',
      'radioGroup',
      'stepper',
      'rate',
      'selectPicker',
      'selectJoin',
      'location',
      'mapMarked',
      'area',
      'datetime',
      'imgUploader',
      'tableField',
      'checkList',
    ], pluginName)
  },
  //把旧版数组升级到新版
  updatePluginData: function (pluginArray) {

    for (let index in pluginArray) {
      let pluginName = pluginArray[index].name;

      //把 switch 升级为 switchOff
      if (pluginName == "switch") {
        pluginArray[index].name = "switchOff";
      } else if (pluginName == "selectJoin") {
        pluginArray[index] = this.updateSelectJoinData(pluginArray[index])

      }

      // form组件升级
      if (_.includes([
        'field',
        'switch',
        'checkboxGroup',
        'radioGroup',
        'stepper',
        'rate',
        'selectPicker',
        'selectJoin',
        'location',
        'mapMarked',
        'area',
        'datetime',
        'imgUploader',
        'formData',
        'submit'
      ], pluginName)) {
        // console.log('pluginArray[index].formName',index,pluginArray[index])
        if (!pluginArray[index].formName) {
          pluginArray[index].formName = "default";
        }
      }
    }

    return pluginArray;

  },
  // 把 selectJoin 数据升级
  updateSelectJoinData(currentPlugin) {
    // console.log('updateCheck')
    // 把columns格式转为cascader
    if (currentPlugin.columns) {
      let _cascader = [];
      currentPlugin.columns.forEach(element => {

        let _children = [];
        if (element.children && element.children != '') {
          element.children.split(',').forEach(item => {
            _children.push({ value: item })
          });
        }
        _cascader.push({
          value: element.text,
          children: _children
        })
      });
      delete currentPlugin.columns;
      currentPlugin.cascader = _cascader
    }
    return currentPlugin;
  },
  handleLink: function (link) {
    if (_.isEmpty(link)) {
      return false;
    }
    //网页跳转link
    var a = document.createElement('a');
    a.href = link;
    var target_href = document.createAttribute("target");
    target_href.nodeValue = "_blank";
    a.setAttributeNode(target_href);
    a.click();
  },
  handleMessage: function (message) {
    if (_.isEmpty(message)) {
      return false;
    }

    Dialog.alert({
      title: '提示',
      message: message,
      closeOnClickOverlay: true
    }).then(() => {
      // on close
    }).catch(() => {
      // on cancel
    });
  },
  handleCopy: function (handle_copy) {

    let message = handle_copy?.message;
    if (!_.isEmpty(message)) {
      if (this.copyTextToClipboard(message) === false) {
        Dialog.alert({
          closeOnClickOverlay: true,
          message: '复制失败，内容：' + message
        })
      } else {
        Dialog.alert({
          closeOnClickOverlay: true,
          message: '内容已复制'
        })
      }
    }


  },
  handleCall: function (handle_call) {

    let phone_number = handle_call?.phone_number;
    if (!_.isEmpty(phone_number)) {


      let call_link = "tel://" + phone_number;
      // console.log('call_link', call_link);
      window.location.href = call_link;
    }


  },
  handleWifi: function (handle_wifi) {

    let password = handle_wifi?.password;
    if (!_.isEmpty(password)) {
      if (this.copyTextToClipboard(password) === false) {
        Dialog.alert({
          closeOnClickOverlay: true,
          message: '复制失败，手动输入密码：' + password
        })
      } else {
        Dialog.alert({
          closeOnClickOverlay: true,
          message: '密码已复制,在手机：WIFI设置 > 粘贴密码 进行连接'
        })
      }
    }

  },
  handleMap: function (handle_map) {

    let location = handle_map?.location;
    if (!_.isEmpty(location)) {
      console.log('location', location)

      let QmapKey = 'BMWBZ-GXD6W-WQYRC-R7ZEC-SONP7-E7FXO';
      let map_link = `https://mapapi.qq.com/web/mapComponents/locationMarker/v/index.html?type=0&marker=coord%3A${location?.latlng?.lat}%2C${location?.latlng?.lng}%3Btitle%3A${encodeURIComponent(location?.poiname)}%3Baddr%3A${encodeURIComponent(location?.poiaddress)}&referer=2weima.com&key=${QmapKey}`;

      //console.log('map_link', map_link)
      window.location.href = map_link;
    }


  },
  handelImages: function (handle_images) {
    let images = handle_images?.map((item) => item?.url);
    // if (typeof src == "string") {
    //   images.push(src);
    // } else if (typeof src == "object") {
    //   images = src;
    // }
    // console.log('images',images)

    ImagePreview({
      images: images,
      closeable: true
    });
  },

  handelImagePreview: function (src) {
    let images = [];
    if (typeof src == "string") {
      images.push(src);
    } else if (typeof src == "object") {
      images = src;
    }

    ImagePreview({
      images: images,
      closeable: true
    });
  },

  copyTextToClipboard: function (text) {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text)
        .then(() => {
          console.log('Text copied to clipboard:', text);
          return true;
        })
        .catch(err => {
          console.error('Failed to copy text to clipboard using Clipboard API:', err);
          return false;
        });
    } else {
      return this.fallbackCopyTextToClipboard(text);
    }
  },
  fallbackCopyTextToClipboard: function (text) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', ''); // 设为只读以防止聚焦
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px'; // 将元素放在屏幕外
    document.body.appendChild(textarea);
    textarea.select();

    try {
      var successful = document.execCommand('copy');
      console.log('Text copy ' + (successful ? 'successful' : 'unsuccessful'));
      return successful;
    } catch (err) {
      console.error('Unable to copy text using document.execCommand:', err);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }





}

export default utils